import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { CallCenter } from 'views';
import { LiveCalls } from 'views';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<LiveCalls />} path="/" />
          <Route element={<CallCenter />} path="/call-center" />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
